import React from "react"
import { Linking, Pressable, View } from "react-native"

import { Center, Vertical } from "@/components/standard/BFLayout"
import { Body, BodyBold } from "@/components/standard/BFText"
import CalendarHeart from "phosphor-react-native/src/icons/CalendarHeart"
import YoutubeLogo from "phosphor-react-native/src/icons/YoutubeLogo"
import { accessAllWebinarsClicked } from "@/analytics/events/communityEvents"

interface EmptyStateProps {
  onBrowseWebinars?: () => void
}

/**
 * Empty state component shown when there are no events
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  onBrowseWebinars = async () => {
    accessAllWebinarsClicked()
    await Linking.openURL(
      "https://www.youtube.com/playlist?list=PLYFkuf_Px0VcTNHzPQuAiFlxMfjOM9vMr"
    )
  },
}) => {
  return (
    <Center className="flex-1 py-5">
      <Vertical className="items-center gap-4">
        <CalendarHeart size={64} color="#121F3A" />

        <Vertical className="items-center gap-1 px-5">
          <BodyBold className="text-center text-midnight-blue">
            More events coming soon!
          </BodyBold>
          <Body className="text-center text-midnight-blue">
            In the meantime, check out one of our past webinars on YouTube
          </Body>
        </Vertical>

        <Pressable
          testID={"browse-webinars"}
          className="mt-2 rounded-full px-4 py-2 flex-row items-center justify-center"
          onPress={onBrowseWebinars}
        >
          <View className="flex-row items-center gap-2">
            <YoutubeLogo size={18} color="#286588" />
            <BodyBold className="text-calm-blue">Browse webinars</BodyBold>
          </View>
        </Pressable>
      </Vertical>
    </Center>
  )
}

export default EmptyState
